import { Navigate } from "react-router-dom";

// project import
import useAuth from "../../hooks/useAuth";

// types
import { GuardProps } from "../../types/auth";

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }: GuardProps) => {
    const { isLogged } = useAuth();

    if (!isLogged) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default AuthGuard;
